import CalorieConscious from 'components/icons/CalorieConscious';
import CarbConscious from 'components/icons/CarbConscious';
import Vegetarian from 'components/icons/Vegetarian';

export * from './routingConstants';
export * from './experimentConstants';
export * from './featureFlags';

// Meal Plan Slugs
export const FRESH_AND_EASY = 'fresh-and-easy';
export const STANDARD = 'standard';

// Basket Page Categories
export const MORE_OPTIONS = 'Other Available Meals';

// Dietary Preferences
export const VEGETARIAN = 'vegetarian';
export const CALORIE_CONSCIOUS = 'calorie-conscious';
export const CARB_CONSCIOUS = 'carb-conscious';

// Spice Levels
export const NOT_SPICY = 'Not Spicy';
export const MILD = 'Mild';
export const MEDIUM = 'Medium';
export const SPICY = 'Spicy';

export const iconTags = {
  [CALORIE_CONSCIOUS]: { icon: CalorieConscious, title: 'Calorie Conscious' },
  [CARB_CONSCIOUS]: { icon: CarbConscious, title: 'Carb Conscious' },
  [VEGETARIAN]: { icon: Vegetarian, title: 'Vegetarian' },
};

// Pause reasons
export const PAUSE_REASON_QUICK_CANCEL = 'reason_quick_cancel';
